

















































































































import Vue from "vue";
import Page from "@/components/Page.vue";
import eventBus from "@/services/eventBus";

import store, { MetRiportStore } from "../services/MetRiportStore";
import MetRiportExportHeadEdit from "../components/MetRiportExportHeadEdit.vue";
import MetRiportExportItemsEdit from "../components/MetRiportExportItemsEdit.vue";
import { load } from "@progress/kendo-vue-intl";

interface Data {
    store: MetRiportStore;
    validHead: boolean;
    isClosing: boolean;
}

interface Methods {
    updateHead(): void;
    closeHead(): void;
    exportRiport(): void;
    importItems(event: Event): void;
    generateDatas(): void;
}

export default Vue.extend<Data, Methods, {}, {}>({
    components: {
        Page,
        MetRiportExportHeadEdit,
        MetRiportExportItemsEdit
    },

    data() {
        return {
            store,
            validHead: true,
            isClosing: false,
        };
    },

    methods: {
        async updateHead() {
            this.store.loading = true;
            await store.updateMetRiportExportHead().then(r => eventBus.$emit('refreshMetRiportExportItems'));
            this.store.loading = false;
        },
        async closeHead() {
            await store.closeMetRiportExport(store.metRiportExportHead.id).then(r => this.$router.go(-1));
        },
        exportRiport(): void {
            this.store.loading = true;
            store.exportMetRiportToCSV();
            this.store.loading = false;
        },
        async importItems(event: Event) {
            this.store.loading = true;
            const fileInput = event.target as HTMLInputElement;
            await store.importMetRiportExportItems(this.store.metRiportExportHead.id, fileInput?.files?.[0])
                .then(r => {
                    fileInput.value = "";
                    eventBus.$emit('refreshMetRiportExportItems');
                });
            this.store.loading = false;
        },
        async generateDatas() {
            this.store.loading = true;
            await store.updateMetRiportExportItemsValues()
                .then(r => {
                    eventBus.$emit('refreshMetRiportExportItems');
                });
            this.store.loading = false;
        },
    }
});
